export enum CHAT_STATUS {
  WAITING = 1,
  PROCESSING = 2,
  COMPLETED = 3
}
